<template>
  <v-card class="pa-2">
    <div style="max-height: 90vh; overflow-y: auto">
      <v-hover v-slot:default="{ hover }" close-delay="200">
        <v-carousel
          height="auto"
          :hide-delimiters="$vuetify.breakpoint.xsOnly"
          hide-delimiter-background
          show-arrows-on-hover
          :cycle="true"
        >
          <v-carousel-item
            v-for="(item, i) in announcements"
            :key="i"
            :src="item.announcementImage"
            :href="item.announcementPath"
            target="_blank"
            style=""
            rel="opener"
          >
            <v-fade-transition>
              <v-row v-if="hover">
                <v-col class="py-0">
                  <div>&nbsp;</div>
                </v-col>

                <v-col cols="auto" class="py-0">
                  <div
                    v-text="item.announcementFullNameTha"
                    class="carousel-item-inner"
                  />
                </v-col>
              </v-row>
            </v-fade-transition>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </div>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      carouselHeight: 300,

      carouselTop: 60,

      announcements: []
    }
  },

  computed: {
    loading() {
      return !this.announcements.length
    }
  },

  async mounted() {
    await this.apiGetAnnouncements()
  },

  methods: {
    async apiGetAnnouncements() {
      try {
        const response = await this.$store.dispatch(
          'dashboard/getAnnouncements'
        )

        if (response.data.message === 'success') {
          this.announcements = response.data.data

            .sort((a, b) => {
              return a.sortOrder - b.sortOrder
            })

            .map(item => {
              if (!item.announcementImage) {
                item.announcementImage =
                  'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
              }

              return item
            })
        }
      } catch (e) {
        console.log(e.response || e)
      }
    },

    onResize() {
      const carousel = this.$refs.carousel

      var position = this.$position(carousel)

      this.carouselTop = position.y

      this.carouselHeight = this.$refs.carousel.clientWidth / 3
    }
  }
}
</script>

<style lang="scss" scoped>
div.carousel-item-inner {
  padding: 12px;

  padding-left: 48px;

  text-align: right;

  color: #fff;

  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.3) 13%,
    rgba(0, 0, 0, 0.5) 25%,
    rgba(0, 0, 0, 0.65) 50%,
    rgba(0, 0, 0, 0.75) 100%
  );
}
</style>

